module.exports = __webpack_public_path__ + "static/media/logo-deciem.18589fdb.jpg";